// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveOwnerPandaDocMutationVariables = Types.Exact<{
  input: Types.SavePandaDocInput;
}>;


export type SaveOwnerPandaDocMutation = { __typename?: 'Mutation', savePandaDoc: { __typename?: 'SavePandaDocResult', pandaDoc: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, owner?: { __typename?: 'BidContractRevision', id: string, bidRevisionStatus: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus, name: string }, canCreatePandaDoc: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined } | null | undefined } | { __typename?: 'ChangeEvent' } | { __typename?: 'Commitment', id: string, status: Types.CommitmentStatus, canCreatePandaDoc: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined } | null | undefined } | { __typename?: 'CommitmentChangeOrder' } | { __typename?: 'DevelopmentCommitment' } | { __typename?: 'Invoice' } | { __typename?: 'LienWaiver' } | null | undefined } } };

export type CommitmentPandaDocFragment = { __typename?: 'Commitment', id: string, status: Types.CommitmentStatus, canCreatePandaDoc: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined } | null | undefined };

export type BidContractPandaDocFragment = { __typename?: 'BidContractRevision', id: string, bidRevisionStatus: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus, name: string }, canCreatePandaDoc: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined } | null | undefined };

export const CommitmentPandaDocFragmentDoc = gql`
    fragment CommitmentPandaDoc on Commitment {
  id
  status
  canCreatePandaDoc {
    allowed
    disabledReasons {
      message
    }
  }
  pandaDoc {
    id
    externalPandaDocUrl
  }
}
    `;
export const BidContractPandaDocFragmentDoc = gql`
    fragment BidContractPandaDoc on BidContractRevision {
  id
  bidRevisionStatus: status {
    code
    name
  }
  canCreatePandaDoc {
    allowed
    disabledReasons {
      message
    }
  }
  pandaDoc {
    id
    externalPandaDocUrl
  }
}
    `;
export const SaveOwnerPandaDocDocument = gql`
    mutation SaveOwnerPandaDoc($input: SavePandaDocInput!) {
  savePandaDoc(input: $input) {
    pandaDoc {
      id
      externalPandaDocUrl
      owner {
        ...BidContractPandaDoc
        ...CommitmentPandaDoc
      }
    }
  }
}
    ${BidContractPandaDocFragmentDoc}
${CommitmentPandaDocFragmentDoc}`;
export type SaveOwnerPandaDocMutationFn = Apollo.MutationFunction<SaveOwnerPandaDocMutation, SaveOwnerPandaDocMutationVariables>;

/**
 * __useSaveOwnerPandaDocMutation__
 *
 * To run a mutation, you first call `useSaveOwnerPandaDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOwnerPandaDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOwnerPandaDocMutation, { data, loading, error }] = useSaveOwnerPandaDocMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveOwnerPandaDocMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveOwnerPandaDocMutation, SaveOwnerPandaDocMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveOwnerPandaDocMutation, SaveOwnerPandaDocMutationVariables>(SaveOwnerPandaDocDocument, options);
      }
export type SaveOwnerPandaDocMutationHookResult = ReturnType<typeof useSaveOwnerPandaDocMutation>;
export type SaveOwnerPandaDocMutationResult = Apollo.MutationResult<SaveOwnerPandaDocMutation>;
export type SaveOwnerPandaDocMutationOptions = Apollo.BaseMutationOptions<SaveOwnerPandaDocMutation, SaveOwnerPandaDocMutationVariables>;